export function hasUsableEncodedBoundary(
  encodedBoundary: string | Array<Array<string>> | null | undefined,
): encodedBoundary is string | Array<Array<string>> {
  if (typeof encodedBoundary === 'string') return encodedBoundary.length > 0;
  return encodedBoundary?.some((polygon) => polygon.some((ring) => ring.length > 0)) ?? false;
}

export function supportsAreaBoundary(areaType: string | undefined): boolean {
  return areaType !== 'university';
}
